/**
 * DrawerHeader - drawer title bar with close control.
 * Custom element: <drawer-header>
 *
 * Refs:
 *   [data-ref="closeButton"]  (required)
 *   [data-ref="count"]  (optional)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { dist } from "./vendor.js";
import { ThemeComponent } from "./theme.js";
class DrawerHeader extends ThemeComponent {
  constructor() {
    super(...arguments), this.close = "", this._onCloseChange = new dist.SimpleEventDispatcher();
  }
  get onCloseChange() {
    return this._onCloseChange.asEvent();
  }
  changeClose(closeState) {
    this.close = closeState, this._onCloseChange.dispatch(closeState);
  }
  init() {
    this.$listen(this.closeButton, "click", () => {
      this._onCloseChange.dispatch(this.close);
    });
  }
}
setFunctionName(DrawerHeader, "DrawerHeader");
const propertyTypes = {};
DrawerHeader.prototype.$name = "DrawerHeader";
DrawerHeader.prototype.$info = JSON.parse('{"name":"DrawerHeader","meta":{"isLegacy":false,"selector":"drawer-header"},"props":[],"refs":[{"selector":"[data-ref=\\"closeButton\\"]","required":true,"propertyKey":"closeButton","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"},{"selector":"[data-ref=\\"count\\"]","required":false,"propertyKey":"count","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"}]}');
DrawerHeader.prototype.$info.component = DrawerHeader;
for (const prop of DrawerHeader.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Drawer/DrawerHeader.ts", {
  DrawerHeader: DrawerHeader
}, void 0);